import type { TofuSurveyQuestionsType } from 'packages/signup/components/TofuSurvey';
import type { CompanyLeadPayload } from 'packages/signup/components/signupForm/types';
import removePIIFromCompanyLeadPayload from 'packages/signup/analytics/removePIIFromCompanyLeadPayload';

const trackSurveySignupAnswerSubmitted = (
  companyLead: CompanyLeadPayload,
  surveyAnswers: TofuSurveyQuestionsType
) => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupAnswerSubmitted',
    data: {
      company_lead: removePIIFromCompanyLeadPayload(companyLead),
      survey_answer: surveyAnswers,
    },
  });
};

export default trackSurveySignupAnswerSubmitted;
